const errorColors = {
  ERROR_50: '#FFEBEE',
  ERROR_100: '#FFCDD2',
  ERROR_200: '#EF9A9A',
  ERROR_300: '#E57373',
  ERROR_400: '#EF5350',
  ERROR_500: '#F44336',
  ERROR_600: '#E53935',
  ERROR_700: '#D32F2F',
  ERROR_800: '#C62828',
  ERROR_900: '#B71C1C',
}

export default errorColors
